/** @file The chord a key press makes: event.code plus modifiers, the platform's Mod key written as Mod. */
import type { Chord, KeyEventLike, Platform } from './types';

/** Codes that only modify; a press of one alone is not a chord yet. */
const MODIFIER_CODES = new Set(['ControlLeft', 'ControlRight', 'ShiftLeft', 'ShiftRight', 'AltLeft', 'AltRight', 'MetaLeft', 'MetaRight', 'OSLeft', 'OSRight', 'CapsLock', 'Fn', 'FnLock']);

/** `Mod`, then `Ctrl` (mac) or `Meta` (win/linux), `Shift`, `Alt`, then the code; null while composing or modifier-only. */
export function chordFromEvent(event: KeyEventLike, platform: Platform): Chord | null {
  if (event.isComposing || event.code === '' || MODIFIER_CODES.has(event.code)) return null;
  const mac = platform === 'mac';
  const [mod, other] = mac ? [event.metaKey, event.ctrlKey] : [event.ctrlKey, event.metaKey];
  const flags: [boolean, string][] = [[mod, 'Mod'], [other, mac ? 'Ctrl' : 'Meta'], [event.shiftKey, 'Shift'], [event.altKey, 'Alt']];
  return [...flags.filter(([on]) => on).map(([, name]) => name), event.code].join('+');
}
